

















































































































































































import {
  Component,
  Prop,
  Watch
} from "vue-property-decorator";
import { FetchState } from "@/shared/types";
import {
  Validator,
  ErrorBag
} from "vee-validate";
import moment from "moment";
import { mixins } from "vue-class-component";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import ContributionsProgressBar from "@/employee/components/shared/ContributionsProgressBar.vue";
import { floor } from "lodash";
import { useContributionStore } from "@/shared/store/contribution";
import { useHsaStore } from "@/shared/store/hsa";
import { useHsaLimitStore } from "@/shared/store/hsalimit";

@Component({
  components: {
    ContributionsProgressBar,
    RadioButton,
    Button
  }
})
export default class Contribution extends mixins(ErrorsMixin) {
  contributionStore = useContributionStore();
  hsaStore = useHsaStore();
  hsaLimitStore = useHsaLimitStore();

  moment = moment;

  @Prop()
  inWizard: boolean;

  formatCurrency = formatCurrency;
  priorContributionsRadio: boolean = null;
  $validator: Validator;
  errors: ErrorBag;
  lastTouched = "";

  get showOtherHsaContribution () {
    return this.planYear < moment().year() + 1;
  }

  get hasPriorContributions () {
    if (this.contributionStore.contributionState.otherHsaContributionAmount > 0) {
      this.priorContributionsRadio = true;
    }

    return this.priorContributionsRadio;
  }

  set hasPriorContributions (value) {
    if (!value) {
      this.contributionStore.setOtherHsaContributionAmount(0);
    }

    this.priorContributionsRadio = value;
  }

  get firstErrorMessageToShow () {
    if (this.lastTouched === "Annual contribution" && this.errors.has("Annual contribution")) {
      return this.errors.first("Annual contribution");
    } else if (this.lastTouched === "Per pay period contribution" && this.errors.has("Per pay period contribution")) {
      return this.errors.first("Per pay period contribution");
    }
    return this.firstErrorMessageFromErrorBag;
  }

  get firstErrorMessageFromErrorBag () {
    const mapOfErrors = this.errors.collect();
    for (const e in mapOfErrors as any) {
      if (mapOfErrors[e] && mapOfErrors[e].length && mapOfErrors[e][0]) {
        return mapOfErrors[e][0];
      }
    }
    return false;
  }

  get employeeContributionsTotal (): number {
    return this.annualEmployeePayrollContribution +
        this.employeePersonalContributions;
  }

  get annualEmployeePayrollContribution () {
    return this.contributionStore.contributionState.annualPreTaxContributionAmount;
  }

  set annualEmployeePayrollContribution (newContribution) {
    this.lastTouched = "Annual contribution";
    this.contributionStore.updateAnnualState(parseFloat(newContribution));
  }

  get annualEmployerContribution () {
    return this.contributionStore.employerContributionForPlanYear;
  }

  get maxAllowedContributionForPlanYear () {
    return this.contributionStore.maxAllowedContribution;
  }

  get annualMaxContribution () {
    return Math.min(this.contributionStore.contributionState.planContributionLimit,
        this.contributionStore.maxAllowedContribution);
  }

  get annualMaxUserContribution () {
    const valueWithoutRounding = (this.annualMaxContribution -
        this.contributionStore.contributionState.otherHsaContributionAmount -
        this.contributionStore.employerContributionForPlanYear);

    // If the max allowed is negative, allow the user to proceed with a value of 0
    return Math.max(0, floor(valueWithoutRounding, 2));
  }

  get employeePersonalContributions () {
    return this.hsaStore.totalEmployeePersonalContributions(this.planYear);
  }

  @Watch("perPayPeriodEmployeeContribution")
  validateInputAmounts () {
    this.$nextTick(() => {
      this.$validator.validate("Per pay period contribution");
      this.$validator.validate("Annual contribution");

    });
  }

  get annualMaxOtherContribution () {
    const valueWithoutRounding = (this.contributionStore.contributionState.planContributionLimit -
        this.contributionStore.contributionState.annualPreTaxContributionAmount -
        this.contributionStore.employerContributionForPlanYear);

    return floor(valueWithoutRounding, 2);
  }

  get isLoaded () {
    return this.contributionStore.fetchState === FetchState.Loaded;
  }

  get isNextDisabled () {
    return this.errors.any() || this.isSubmitting;
  }

  get perPayPeriodEmployeeContribution () {
    return this.contributionStore.perPayPeriodState;
  }

  set perPayPeriodEmployeeContribution (newContribution) {
    this.lastTouched = "Per pay period contribution";
    this.contributionStore.updatePerPayPeriodState(newContribution);
  }

  get priorContribution () {
    return this.contributionStore.contributionState.otherHsaContributionAmount || 0;
  }

  set priorContribution (newContribution) {
    this.contributionStore.setOtherHsaContributionAmount(newContribution);
  }

  get showPriorContributionsInput () {
    return this.hasPriorContributions;
  }

  mounted () {
    this.hsaLimitStore.getHsaAccountLimits();
    this.contributionStore.fetchContribution().catch(this.handleError);
  }

  get isDecemberOnBoarding () {
    return !this.contributionStore.hasNoPayPeriods && this.contributionStore.isFirstEnrollmentInDec;
  }

  get planYear () {
    return moment(this.contributionStore.effectiveDate).year();
  }

  get showPayDateMessage () {
    return !this.contributionStore.hasNoPayPeriods && this.contributionStore.contribution.nextEffectivePayrollDate;
  }

  get possibleOverContribute () {
    const totalContributions = this.priorContribution + this.annualEmployerContribution;
    return totalContributions > this.annualMaxContribution;
  }

  get nextPayDate () {
    return moment(this.contributionStore.contribution.nextEffectivePayrollDate).format("MM/DD/YYYY");
  }

  get validateAnnualContribution () {
    return {
      required: true,
      decimal: 2,
      min_value_usd: 0,
      max_value_usd: this.annualMaxUserContribution
    };
  }

  get validateOtherContribution () {
    return {
      decimal: 2,
      min_value_usd: 0,
      max_value_usd: this.annualMaxContribution
    };
  }

  onSubmit () {
    if (this.isNextDisabled) {
      return;
    }

    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }
      this.isSubmitting = true;
      if (!this.contributionStore.hasNoPayPeriods) {
        this.contributionStore.updateContribution().then(() => {
          this.$emit("complete");
          this.isSubmitting = false;
        }).catch(this.handleError);
      } else {
        this.$emit("complete");
        this.isSubmitting = false;
      }
    });
  }
}
